<script lang="ts" setup>
type RTextSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'

const props = defineProps<{
  type?:
    | 'primary'
    | 'medium'
    | 'disabled'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'danger'
    | 'info'
    | 'contrast'
  size?: RTextSize
  bold?: boolean
}>()

const tagClasses = computed(() => {
  return {
    'myz-text': true,
    [`myz-text--${props.type}`]: props.type !== undefined,
    [`myz-text--${props.size}`]: props.size !== undefined,
    ['myz-text--bold']: props.bold
  }
})
</script>

<template>
  <span :class="tagClasses">
    <slot />
  </span>
</template>
